

function Feed () {
  return (
    <div className="facebookFlux">
<div class="fb-page" data-href="https://www.facebook.com/legendebeaumont" data-tabs="timeline" data-width="" data-height="" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true"><blockquote cite="https://www.facebook.com/legendebeaumont" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/legendebeaumont">La Légende de Beaumont: Charles-Quint et les 3 Auvergnats</a></blockquote></div>    </div>
  )
}

export default Feed